// import React, { useState } from 'react';
// import axios from 'axios';
// import { useHistory } from 'react-router-dom';
// import { Form, Button, Card, Row, Col, Alert } from 'react-bootstrap';
// import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';

// const PlaceOrderModal = ({ serviceId, serviceName, description, charges, sellerId }) => {
//     const history = useHistory();
//     const authInfo = useSelector((state) => state.auth.authInfo);
//     const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

//     const [paymentType, setPaymentType] = useState('milestones');
//     const [milestones, setMilestones] = useState([
//         { title: serviceName, dueDate: '2025-05-15', amount: charges, description: '' },
//     ]);
//     const [error, setError] = useState(null);
//     const [loading, setLoading] = useState(false);

//     // Helpers
//     const handleMilestoneChange = (index, field, value) => {
//         const updated = [...milestones];
//         updated[index][field] = value;
//         setMilestones(updated);
//     };
//     const addMilestone = () => setMilestones([...milestones, { title: '', dueDate: '', amount: '' }]);
//     const removeMilestone = (index) =>
//         setMilestones(milestones.filter((_, idx) => idx !== index));

//     const totalAmount = milestones.reduce(
//         (sum, m) => sum + parseFloat(m.amount || 0),
//         0
//     );

//     const handleSubmit = async () => {
//         setError(null);

//         if (!isLoggedIn) {
//             setError('You must be logged in to place an order.');
//             return;
//         }

//         // Validate milestone total matches service price
//         if (
//             paymentType === 'milestones' &&
//             totalAmount.toFixed(2) !== parseFloat(charges).toFixed(2)
//         ) {
//             setError(`Total milestone amount must equal $${charges}`);
//             return;
//         }

//         setLoading(true);
//         try {
//             const payload = {
//                 title: serviceName,
//                 description: description,
//                 budget: parseFloat(charges),
//                 clientId: authInfo.id,   // pulled from JWT
//                 sellerId: sellerId,
//                 serviceId: serviceId,
//                 isProductProject: false,        // adjust if you support product projects
//                 milestones: milestones.map((m) => ({
//                     name: m.title,
//                     description: m.title,               // or let user fill in
//                     amount: parseFloat(m.amount),
//                     assignedTo: sellerId,
//                     dueDate: m.dueDate,
//                 })),
//             };

//             const { data } = await axios.post(
//                 '/user/project/create',
//                 payload,
//                 {
//                     headers: {
//                         Accept: 'application/json',
//                         'Content-Type': 'application/json;charset=UTF-8',
//                         Authorization: `Bearer ${authInfo.token}`,
//                     },
//                 }
//             );

//             const projectId = data.project._id;
//             toast.success('Project created! Redirecting to payment…');
//             history.push(`/checkout/milestones/${projectId}`);
//         } catch (err) {
//             console.error(err);
//             const msg = err.response?.data?.error || 'Failed to create project.';
//             setError(msg);
//             toast.error(msg);
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="container py-4">
//             <h2 className="mb-4">Place Your Order</h2>

//             <Row className="g-4">
//                 <Col md={8}>
//                     {/* Service Details */}
//                     <Card className="mb-4 shadow-sm">
//                         <Card.Header><h3 className="h5">Service Details</h3></Card.Header>
//                         <Card.Body>
//                             <p className="mb-3">{serviceName}</p>
//                             <div dangerouslySetInnerHTML={{ __html: description }} />
//                             <p><strong>Price:</strong> ${charges}</p>
//                         </Card.Body>
//                     </Card>

//                     {/* Payment Method */}
//                     <Card className="mb-4 shadow-sm">
//                         <Card.Header><h3 className="h5">Payment Method</h3></Card.Header>
//                         <Card.Body>
//                             <Form.Check
//                                 type="radio"
//                                 id="payFull"
//                                 name="paymentType"
//                                 label="Pay Full Amount Upfront"
//                                 value="full"
//                                 checked={paymentType === 'full'}
//                                 onChange={e => setPaymentType(e.target.value)}
//                                 className="mb-3"
//                             />
//                             <Form.Check
//                                 type="radio"
//                                 id="payMilestones"
//                                 name="paymentType"
//                                 label="Pay in Milestones"
//                                 value="milestones"
//                                 checked={paymentType === 'milestones'}
//                                 onChange={e => setPaymentType(e.target.value)}
//                             />
//                         </Card.Body>
//                     </Card>

//                     {/* Milestones Definition */}
//                     {paymentType === 'milestones' && (
//                         <Card className="mb-4 shadow-sm">
//                             <Card.Header className="d-flex justify-content-between align-items-center">
//                                 <h3 className="h5 mb-0">Define Milestones</h3>
//                                 <Button size="sm" onClick={addMilestone}>+ Add Milestone</Button>
//                             </Card.Header>
//                             <Card.Body>
//                                 {milestones.map((m, idx) => (
//                                     <div
//                                         key={idx}
//                                         className="bg-light border rounded p-3 mb-3 position-relative"
//                                     >
//                                         <h6>Milestone {idx + 1}</h6>
//                                         <Row className="g-3">
//                                             <Col md={5}>
//                                                 <Form.Group>
//                                                     <Form.Label>Title</Form.Label>
//                                                     <Form.Control
//                                                         type="text"
//                                                         value={m.title}
//                                                         onChange={e =>
//                                                             handleMilestoneChange(idx, 'title', e.target.value)
//                                                         }
//                                                     />
//                                                 </Form.Group>
//                                             </Col>
//                                             <Col md={4}>
//                                                 <Form.Group>
//                                                     <Form.Label>Due Date</Form.Label>
//                                                     <Form.Control
//                                                         type="date"
//                                                         value={m.dueDate}
//                                                         onChange={e =>
//                                                             handleMilestoneChange(idx, 'dueDate', e.target.value)
//                                                         }
//                                                     />
//                                                 </Form.Group>
//                                             </Col>
//                                             <Col md={3}>
//                                                 <Form.Group>
//                                                     <Form.Label>Amount ($)</Form.Label>
//                                                     <Form.Control
//                                                         type="number"
//                                                         value={m.amount}
//                                                         onChange={e =>
//                                                             handleMilestoneChange(idx, 'amount', e.target.value)
//                                                         }
//                                                     />
//                                                 </Form.Group>
//                                             </Col>
//                                         </Row>
//                                         <Row className='g-3 mt-2'>
//                                             <Form.Group>
//                                                 <Form.Label>Description</Form.Label>
//                                                 <Form.Control
//                                                     as="textarea"
//                                                     rows={6}
//                                                     value={m.description}
//                                                     onChange={e =>
//                                                         handleMilestoneChange(idx, 'description', e.target.value)
//                                                     }
//                                                 />
//                                             </Form.Group>
//                                         </Row>


//                                         {milestones.length > 1 && (
//                                             <Button
//                                                 variant="outline-danger"
//                                                 size="sm"
//                                                 className="position-absolute"
//                                                 style={{ top: 10, right: 10 }}
//                                                 onClick={() => removeMilestone(idx)}
//                                             >
//                                                 ×
//                                             </Button>
//                                         )}
//                                     </div>
//                                 ))}

//                                 <div className="d-flex justify-content-between mt-3">
//                                     <strong>Total:</strong>
//                                     <strong>${totalAmount.toFixed(2)}</strong>
//                                 </div>

//                                 {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
//                             </Card.Body>
//                         </Card>
//                     )}
//                 </Col>

//                 {/* Sidebar & Submit */}
//                 <Col md={4}>
//                     <Card className="mb-4 shadow-sm">
//                         <Card.Header><h3 className="h5">Order Summary</h3></Card.Header>
//                         <Card.Body>
//                             <div className="d-flex justify-content-between mb-2">
//                                 <span>Service Price</span>
//                                 <span>${charges}</span>
//                             </div>
//                             <hr />
//                             <div className="d-flex justify-content-between fw-bold">
//                                 <span>Total</span>
//                                 <span>${charges}</span>
//                             </div>
//                             <Button
//                                 variant="primary"
//                                 className="w-100 mt-3"
//                                 onClick={handleSubmit}
//                                 disabled={loading}
//                             >
//                                 {loading ? 'Submitting…' : 'Continue to Payment'}
//                             </Button>
//                         </Card.Body>
//                     </Card>
//                 </Col>
//             </Row>
//         </div>
//     );
// };

// export default PlaceOrderModal;

import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FaTrash } from 'react-icons/fa';
import UserAgreementService from './UserAgreementService';

// Terms Modal Component
const TermsModal = ({ show, onHide, onAccept, onDecline, termsContent, loading }) => {
  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Terms and Conditions</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '400px', overflowY: 'auto' }}>
        {loading ? (
          <div className="text-center p-4">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <p className="mt-2">Loading terms and conditions...</p>
          </div>
        ) : (
          <div style={{ whiteSpace: 'pre-wrap', lineHeight: '1.5' }}>
            {(termsContent || 'No terms found.').replace(/<[^>]+>/g, '')}
          </div>

        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onDecline}>
          Decline
        </Button>
        <Button variant="primary" onClick={onAccept} disabled={loading}>
          Accept Terms
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const PlaceOrderModal = ({
  show = true,
  onHide,
  serviceId,
  serviceName,
  description,
  charges,
  sellerId
}) => {
  const authInfo = useSelector((state) => state.auth.authInfo);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const history = useHistory();

  const [milestones, setMilestones] = useState([]);
  const [title, setTitle] = useState('');
  const [desc, setDesc] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [amount, setAmount] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  
  // Terms Modal State
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [termsContent, setTermsContent] = useState('');
  const [termsLoading, setTermsLoading] = useState(false);

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  const addMilestone = () => {
    if (!title.trim() || !amount || !dueDate) {
      toast.error("All fields (title, amount, due date) are required.");
      return;
    }

    const parsedAmount = parseFloat(amount);
    if (parsedAmount <= 0) {
      toast.error("Amount must be greater than 0");
      return;
    }

    if (milestones.length > 0) {
      const lastDate = new Date(milestones[milestones.length - 1].dueDate);
      const newDate = new Date(dueDate);
      if (newDate <= lastDate) {
        toast.error("Due date must be after the previous milestone's due date.");
        return;
      }
    }

    setMilestones([
      ...milestones,
      { title: title.trim(), description: desc.trim(), dueDate, amount: parsedAmount }
    ]);

    setTitle('');
    setDesc('');
    setDueDate('');
    setAmount('');
  };

  const removeMilestone = (idx) => {
    setMilestones(milestones.filter((_, index) => index !== idx));
  };

  const totalAmount = milestones.reduce((sum, m) => sum + parseFloat(m.amount || 0), 0);

  const handleTermsClick = async (e) => {
    e.preventDefault();

    setTermsLoading(true);
    setShowTermsModal(true);

    try {
      const documents = await UserAgreementService.getRequiredDocuments('order_placement', 'buyer');
      const termsText = documents?.data
        ?.map(doc => `${doc.title}\n\n${doc.content}`)
        .join('\n\n---\n\n') || 'No terms found.';

      setTermsContent(termsText);
    } catch (error) {
      console.error('Error fetching terms:', error);
      setTermsContent('Failed to load terms and conditions. Please try again.');
      toast.error('Failed to load terms.');
    } finally {
      setTermsLoading(false);
    }
  };

  const handleAcceptTerms = () => {
    setTermsAccepted(true);
    setShowTermsModal(false);
    toast.success("Terms and conditions accepted!");
  };

  const handleDeclineTerms = () => {
    setTermsAccepted(false);
    setShowTermsModal(false);
    toast.info("You must accept the terms to proceed.");
  };

  const handleSubmit = async () => {
    if (!isLoggedIn) {
      toast.error('Please log in to place an order.');
      return;
    }

    if (!termsAccepted) {
      toast.error('Please accept the Terms and Conditions before placing the order.');
      return;
    }

    if (milestones.length === 0) {
      return toast.error("Please add at least one milestone.");
    }

    if (milestones.some(m => !m.title || !m.amount || !m.dueDate)) {
      return toast.error("All milestones must have title, amount, and due date.");
    }

    for (let i = 1; i < milestones.length; i++) {
      const prevDate = new Date(milestones[i - 1].dueDate);
      const currDate = new Date(milestones[i].dueDate);
      if (currDate <= prevDate) {
        return toast.error(`Milestone ${i + 1} due date must be after Milestone ${i}`);
      }
    }

    if (totalAmount.toFixed(2) !== parseFloat(charges).toFixed(2)) {
      return toast.error(`Total milestone amount must equal $${charges}`);
    }

    const payload = {
      title: serviceName,
      description,
      budget: parseFloat(charges),
      clientId: authInfo.id,
      sellerId,
      serviceId,
      isProductProject: false,
      milestones: milestones.map((m) => ({
        name: m.title,
        description: m.description,
        amount: m.amount,
        dueDate: m.dueDate,
        assignedTo: sellerId
      }))
    };

    try {
      const { data } = await axios.post('/user/project/create', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authInfo.token}`,
        },
      });

      toast.success('Project created!');
      history.push(`/checkout/milestones/${data.project._id}`);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to create project');
    }
  };

  const todayDate = getTodayDate();

  return (
    <>
      <Modal show={show} onHide={onHide} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Create Project Milestones</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {milestones.map((m, idx) => (
            <Card className="mb-3" key={idx}>
              <Card.Body>
                <div className="d-flex justify-content-between">
                  <div>
                    <strong>Milestone {idx + 1}: {m.title}</strong>
                    <p className="mb-1">{m.description}</p>
                    <small>{m.dueDate} • ${m.amount}</small>
                  </div>
                  <Button variant="link" onClick={() => removeMilestone(idx)}>
                    <FaTrash className="text-danger" />
                  </Button>
                </div>
              </Card.Body>
            </Card>
          ))}

          <Form className="mt-4">
            <Form.Group className="mb-2">
              <Form.Label>Milestone Title</Form.Label>
              <Form.Control
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="e.g., Design Review"
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={desc}
                onChange={(e) => setDesc(e.target.value)}
                placeholder="Add any details or expectations"
              />
            </Form.Group>
            <Row>
              <Col>
                <Form.Group className="mb-2">
                  <Form.Label>Due Date</Form.Label>
                  <Form.Control
                    type="date"
                    min={todayDate}
                    value={dueDate}
                    onChange={(e) => setDueDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-2">
                  <Form.Label>Amount ($)</Form.Label>
                  <Form.Control
                    type="number"
                    value={amount}
                    placeholder='e.g., 100'
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Button variant="outline-dark" className="w-100 mt-2" onClick={addMilestone}>
              + Add Milestone
            </Button>
          </Form>

          <div className="d-flex justify-content-between mt-4">
            <strong>Total Project Value</strong>
            <strong>${totalAmount.toFixed(2)}</strong>
          </div>

          <div className="mt-4 p-3 border rounded bg-light">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="mb-1">Terms and Conditions</h6>
                <small className="text-danger">
                  {termsAccepted ? (
                    <span className="text-success">Terms accepted</span>
                  ) : (
                    'Please accept before creating a project.'
                  )}
                </small>
              </div>
              <Button variant="outline-primary" size="sm" onClick={handleTermsClick}>
                {termsAccepted ? 'View Terms' : 'Review Terms'}
              </Button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onHide}>Go Back</Button>
          <Button
            className="outline-primary"
            onClick={handleSubmit}
            disabled={!termsAccepted}
          >
            Next
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Terms and Conditions Modal - Using your existing component */}
      <TermsModal
        show={showTermsModal}
        onHide={() => setShowTermsModal(false)}
        onAccept={handleAcceptTerms}
        onDecline={handleDeclineTerms}
        termsContent={termsContent}
        loading={termsLoading}
      />
    </>
  );
};

export default PlaceOrderModal;